// Twin of backend/auth_service/routers/users.py -> _validate_password: the server
// is the authority, this only lets a form say so before the round trip (a reset
// that the server refuses must not look like it worked).
export const PASSWORD_MIN_LENGTH = 12;

export function meetsPasswordPolicy(password: string): boolean {
  return (
    password.length >= PASSWORD_MIN_LENGTH &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}
